
<div class="container">

  <div class="w-full flex justify-center my-10 flex-col text-center items-center">
    <img [src]="cdnUrl + '/content/assets/images/error404.svg'" alt="404 page error"
      class="lg:w-[748px] w-full lg:h-[333px] object-contain">
    <h3 class="mt-5">صفحه مورد نظر یافت نشد:(</h3>
    <a href="/" class="text-blue-500 my-5">
      بازگشت به صفحه اصلی 
    </a>

  </div>

</div>
  